import { Turbo } from '@hotwired/turbo-rails'
import createEstimateSubscription from './channels/estimate_channel'

Turbo.session.drive = false
// console.log('estimation experience')
const url = new URL(window.location.href)
const search_params = url.searchParams

// Loading
// TODO
const showLoading = () => {
  document.body.innerHTML = '<div>CHARGEMENT...</div>'
}

createEstimateSubscription()

// Landbot config
// const myLandbot = new LandbotFullpage({
//   index: `https://landbot.io/u/H-426240-G5O96BZSSDYAJN8A/index.html?token=${search_params.get('token')}`,
// })

// Landbot config
// const myLandbot = new Landbot.Container({
//   container: '#myLandbot',
//   configUrl: `https://storage.googleapis.com/landbot.pro/v3/H-1413794-Y2V7XV7L4BWNBUYJ/index.json?token=${search_params.get('token')}`,
// })

var myLandbot = new Landbot.Fullpage({
	container: '#myLandbot',
	configUrl: 'https://storage.googleapis.com/landbot.pro/v3/H-1413794-Y2V7XV7L4BWNBUYJ/index.json',
});

// document.addEventListener('landbot-msg-receive', (data) => {
// 	console.log('NEW MESSAGE')
// 	console.log(data)
myLandbot.on('landbot-msg-receive', (data) => {
  if (data.action == 'finish') { setTimeout(showLoading, 3000) }
})
